import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from 'components';
import { CardLeaderboard, LeaderboardCardsWrapper } from 'fragments';
import { LeaderboardAction } from 'store';
import { FindLoad, Images } from 'utils';

const ACTION_TYPE = 'GET_LEADERBOARD';

export const Leaderboard = () => {
  const dispatch = useDispatch();
  const loading = FindLoad(ACTION_TYPE);
  const leaderboardList = useSelector((state) => state?.leaderboard?.leaderboardList?.history);
  const topAgent = !!leaderboardList?.topAgents?.length && leaderboardList?.topAgents?.[0];
  const remainingTopAgents = !!leaderboardList?.topAgents?.length && leaderboardList?.topAgents?.slice(1);
  const topOffice = !!leaderboardList?.topOffices?.length && leaderboardList?.topOffices?.[0];
  const remainingTopOffices = !!leaderboardList?.topOffices?.length && leaderboardList?.topOffices?.slice(1);


  useEffect(() => {
    dispatch(LeaderboardAction.getLeaderboard());
  }, [dispatch]);

  if (loading?.length) {
    return <Loader />;
  }

  return (
    <div className='leaderboard-wrapper'>
      {!!leaderboardList?.topAgents?.length &&
        <div className='leaderboard-box'>
          <LeaderboardCardsWrapper
            title='Top Agent'
            noYetText='Top Agent'
          >
            <CardLeaderboard
              bigImg={Images.topAgent}
              title={topAgent?.agent || ''}
              description={topAgent?.office || ''}
              wrapperStyle={{ background: '#E4F3FF', padding: '16px' }}
            />
          </LeaderboardCardsWrapper>
          {remainingTopAgents?.length &&
            <LeaderboardCardsWrapper
              title='Other Spots'
              boxStyle={{ maxHeight: '62vh' }}
              noYetText='Other Spots'
            >
              {remainingTopAgents.map((remainingTopAgent, index) => (
                <CardLeaderboard
                  title={remainingTopAgent?.agent || ''}
                  directory={remainingTopAgent?.office || ''}
                  index={index + 2}
                  wrapperStyle={{ background: '#FFF', border: '1px solid #E6ECF3', padding: '8px' }}
                />
              ))}
            </LeaderboardCardsWrapper>
          }
        </div>
      }
      {!!leaderboardList?.topOffices?.length &&
        <div className='leaderboard-box'>
          <LeaderboardCardsWrapper
            title='Top Office'
            noYetText='Top Office'
          >
            <CardLeaderboard
              bigImg={Images.topOffice}
              title={topOffice?.office || ''}
              wrapperStyle={{ background: '#FFF7DE', padding: '16px' }}
            />
          </LeaderboardCardsWrapper>

          {!!remainingTopOffices?.length &&
            <LeaderboardCardsWrapper
              title='Other Spots'
              boxStyle={{ maxHeight: '62vh' }}
              noYetText='Other Spots'
            >
              {remainingTopOffices.map(( remainingTopOffice, index) => (
                <CardLeaderboard
                  title={remainingTopOffice?.office || ''}
                  index={index + 2}
                  indexStyle={{ background: '#FFF7DE' }}
                  wrapperStyle={{ background: '#FFF', border: '1px solid #E6ECF3', padding: '8px' }}
                />
              ))}
            </LeaderboardCardsWrapper>
          }
        </div>
      }
    </div>
  );
};

